(() => {
  function init(root) {
    root.querySelectorAll('.af-mobile-menu:not([data-af-ready])').forEach(menu => {
      menu.dataset.afReady = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          // Dawn closes its language disclosure on keyup and restores focus itself.
          const localization = event.target.closest('localization-form');
          if (localization?.querySelector('.localization-form__select')?.getAttribute('aria-expanded') === 'true') return;
          const nested = event.target.closest('.af-catalog-disclosure[open]');
          if (nested) { nested.open = false; nested.querySelector('summary').focus(); event.stopPropagation(); return; }
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      menu.querySelectorAll('a').forEach(link => {
        if (!link.closest('localization-form')) link.addEventListener('click', () => { menu.open = false; });
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

document.addEventListener('keydown', event => { if(event.key==='Escape'){ const open=document.querySelector('.af-desktop-menu .af-catalog-disclosure[open]'); if(open){open.open=false;open.querySelector('summary').focus();} } });
document.addEventListener('click', event => { document.querySelectorAll('.af-desktop-menu .af-catalog-disclosure[open]').forEach(d=>{if(!d.contains(event.target))d.open=false;}); });
